export default __webpack_public_path__ + "static/pixea-example5-94f764f09ff5c29e87edd845f029ed08.png";